import { Modal } from '../../../Modal';
import { Button, Card, Typography } from '../../../symphony/ui';
import { EarnCreditsOffer } from '../../../symphony/earn-credits/EarnCreditsOffer';
import { SETTINGS_PAGE } from '../settings-shared';
import { BuyCreditsProps, useBuyCredits } from './use-buy-credits';
import styles from './BuyCreditsModal.module.css';

// The desktop "Buy more credits" modal (Figma 12889-206300) — a one-time top-up confirm that replaces
// the bare deeplink the "Get more credits" action used to fire. Chrome only: the amount/price, the BI
// and the checkout hand-off all come from useBuyCredits, shared 1:1 with the mobile BuyCreditsSheet.
export function BuyCreditsModal({ open, onClose, topup, planName, checkoutHref }: BuyCreditsProps) {
  const vm = useBuyCredits({ onClose, topup, planName, checkoutHref });

  return (
    <Modal
      open={open}
      onClose={vm.close}
      size="minimum"
      maxHeightPx={650}
      scrollBody
      labelledBy="buy-credits-title"
      title={vm.title}
      headerSeparator
      footerSeparator
      contentClassName={styles.body}
      footer={
        <>
          <Button variant="outlined" onClick={vm.close}>
            {vm.closeLabel}
          </Button>
          <Button href={vm.checkoutHref} onClick={vm.onCheckout}>
            {vm.checkoutLabel}
          </Button>
        </>
      }
    >
      {/* The subtitle sits UNDER the header rule, in the body's primary ink — not in the DS header's
          secondary description slot, which is where it used to live (design QA, Monday 12814394203). */}
      <Typography variant="p2" color="primary">
        {vm.subtitle}
      </Typography>
      <Card variant="stone" size="sm" className={styles.pack}>
        <div className={styles.content}>
          <div className={styles.row}>
            <Typography variant="h2" component="span">
              {vm.amountLabel}
            </Typography>
            <Typography variant="h2" component="span">
              {vm.priceLabel}
            </Typography>
          </div>
          <Typography variant="p2" component="div" color="secondary" align="end">
            {vm.oneTimeLabel}
          </Typography>
        </div>
      </Card>
      {/* The premium path: a top-tier user has no upgrade left to cannibalize, so the free way to
          more credits is offered under the pack — secondary to Check out, which is untouched. */}
      <EarnCreditsOffer entry={{ kind: 'buy_credits' }} pageName={SETTINGS_PAGE.page_name} />
    </Modal>
  );
}
